import { render, staticRenderFns } from "./global-video-screen-recording-popup.vue?vue&type=template&id=3c501a20&scoped=true"
import script from "./global-video-screen-recording-popup.vue?vue&type=script&lang=js"
export * from "./global-video-screen-recording-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c501a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c501a20')) {
      api.createRecord('3c501a20', component.options)
    } else {
      api.reload('3c501a20', component.options)
    }
    module.hot.accept("./global-video-screen-recording-popup.vue?vue&type=template&id=3c501a20&scoped=true", function () {
      api.rerender('3c501a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/global-video-screen-recording-popup.vue"
export default component.exports